import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
  siteKey: '6LcpLoomAAAAAB5Rjt0kBdFMw2WW5Q-DiZNfcIiQ',
  apiKey: 'AIzaSyB1ptufagOhTEghtl-wMoDERS7RS3ZDlu0',
  authDomain: 'pmm-gpt.firebaseapp.com',
  projectId: 'pmm-gpt',
  storageBucket: 'pmm-gpt.appspot.com',
  messagingSenderId: '105048547531',
  appId: '1:105048547531:web:74845a9395947e75c7bb4e',
  measurementId: "G-E3N02D1B10"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);

const auth = firebaseApp.auth();

export { auth };